import { render, staticRenderFns } from "./BBCheckboxGroup.vue?vue&type=template&id=b31f2130"
import script from "./BBCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./BBCheckboxGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b31f2130')) {
      api.createRecord('b31f2130', component.options)
    } else {
      api.reload('b31f2130', component.options)
    }
    module.hot.accept("./BBCheckboxGroup.vue?vue&type=template&id=b31f2130", function () {
      api.rerender('b31f2130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/content/BBForm/BBCheckboxGroup.vue"
export default component.exports